var _goto_interval;
var _goto_term;
var _term;
var _submit = false;
var _typing_timer;
var _done_typing_interval = 1000;
var _done_typing = false;
$(function () {

	// For clicking the back button if a modal
	// $(window).on('popstate', function (e) {
	// 	var state = e.originalEvent.state;
	// 	if (!state) return;
	// 	$('#goToModal').modal('hide');
	// });

	// Grab location
	$(document).on('show.bs.modal', '#goToModal', function (e) {
		setInitialUrl({ get: true, app: 'search' });
		sessionStorage.setItem('initial_title', document.title);
	});
	//- Check for any recent visited pages
	$(document).on('shown.bs.modal', '#goToModal', function (e) {
		//- Make sure stuff is set
		$('#goToModal #go_to_termm').removeClass('no-text').attr('placeholder', i18n.__('search') + '...');
		$('#goToModal #goto-append').addClass('hidden').removeClass('dot-wrapper').html('');
		$('#goToModal .goto-spinner').addClass('hidden');
		$('#goToModal #go_to_termm').focus();
	})
	//- Event on close
	$(document).on('hide.bs.modal', '#goToModal', function (e) {
		// setInitialUrl({ set: true, app: 'search' });
		$('#goToModal #go_to_termm').val('');
		$('#goToModal #goto-append').addClass('hidden').html('');
		$('#goToModal .goto-spinner').addClass('hidden');
		_goto_term = null;
		_submit = false;
	});
	// $(document).on('hidden.bs.modal', '#goToModal', function (e) {
	// 	setInitialUrl({ set: true, app: 'search' });
	// });
	//- Catching any up or down on keyup
	$(document).on('keyup', '#goToModal #go_to_termm', function (e) {
		//- If advanced search is open we stop here
		if ($('.mail_advanced_search_div').is(':visible')) {
			return;
		}
		//- Code
		var _key = e.key;
		//- Check key
		switch (_key) {
			case "Shift":
			case "Meta":
			case "Control":
			case "Alt":
			case "Enter":
			case "Esc":
			case "Escape":
			case "Tab":
			case "ArrowDown":
			case "Down":
			case "ArrowUp":
			case "Up":
				e.preventDefault();
				return;
			case "ArrowLeft":
			case "Left":
			case "ArrowRight":
			case "Right":
				//- case "Delete":
				//- case "Backspace":
				return;
			default:
			// Cancel the default action to avoid it being handled twice
			//- e.preventDefault();
		}
		clearTimeout(_typing_timer);
		if ($('#goToModal #go_to_termm').val()) {
			$('#goToModal .goto-spinner').removeClass('hidden');
			_typing_timer = setTimeout(doneTyping, _done_typing_interval);
		}
		else {
			$('#goToModal .goto-spinner').addClass('hidden');
		}
	});
	function doneTyping() {
		//- If already submited return
		if (_submit) {
			return;
		}
		//- Value
		_term = $('#goToModal #go_to_termm').val();
		//- If term is already stored
		if (_term === _goto_term) {
			_submit = false;
			return;
		}
		//- Less than 3 chars
		if (_term.length < 2) {
			$('#goToModal #goto-append').addClass('hidden').html('');
			_submit = false;
			_goto_term = null;
			return;
		}
		//- Show loader
		$('#goToModal .goto-spinner').removeClass('hidden');
		//- Set submit
		_submit = true;
		//- Set term in var to prevent same query several times
		_goto_term = _term;
		//- Call sub function
		_goto_sub();
	}
	//- Here is the core :)
	$(document).on('keydown', '#goToModal #go_to_termm', function (e) {
		// Do nothing if event already handled
		if (e.defaultPrevented) {
			return;
		}
		//- If already submited return
		if (_submit) {
			return;
		}
		//- Code
		var _key = e.key;
		//- Check key
		switch (_key) {
			case "Shift":
			case "Meta":
			case "Control":
			case "Alt":
			case "Enter":
			case "Esc":
			case "Escape":
			case "Tab":
			case "ArrowDown":
			case "Down":
			case "ArrowUp":
			case "Up":
				e.preventDefault();
				return;
			case "ArrowLeft":
			case "Left":
			case "ArrowRight":
			case "Right":
			case "Delete":
			case "Backspace":
				return;
			default:
			// Cancel the default action to avoid it being handled twice
			//- e.preventDefault();
		}
	})
	//- Search again
	$(document).on('click', '.goto-search-again', function (e) {
		_goto_term = null;
		_term = $(this).data('term');
		//- Search
		_goto_sub();
		//- Add to input
		$('#go_to_termm').val(_term);
		//- Go to top
		$('.modal-body').animate({ scrollTop: 0 }, 1000)
	})
})
// Called from history
function _goToFromHistory(_term) {
	_goto_term = null;
	_term = _term;
	//- Set term
	$('#goToModal #go_to_termm').val(_term);
	//- Call sub function
	_goto_sub({ no_store: true, term: _term });
}
//- Calling search
function _goto_sub(options) {
	options = options || {};
	options.no_store = typeof options.no_store !== 'undefined' ? options.no_store : false;
	_term = options.term || _term || $('#goToModal #go_to_termm').val();
	$.ajax({
		type: "POST",
		url: '/goto',
		data: { term: _term },
		statusCode: {
			// Error
			500: function (data) {
				$('#goToModal .goto-spinner').addClass('hidden');
				_submit = false;
				_goto_term = null;
				console.error('ERROR with goto');
				return;
			},
			// Done
			200: function (data) {
				//- console.log('data', data);
				if (!options.no_store) {
					document.title = i18n.__('search') + ': ' + _term;
					var _jsurl = createJSURL({ st: _term });
					setURLBar(`/search?g=${_jsurl}`, { st: _term, app: 'search', url: `/search?g=${_jsurl}` });
				}
				//- Vars
				var _html_navigation = '';
				var _html_emails = '';
				var _html_mailboxes = '';
				var _html_customers = '';
				var _html_companies = '';
				var _html_files = '';
				var _html = '';
				//- EMAILS
				$.each(data.emails, function (i, v) {
					_html_emails += _searchHtml(v, 'email');
				})
				var _more_emails = data.count_emails > 10 ? '<div class="mt-10"><a class="btn btn-info btn-sm" href="#" onclick="goToDoSearchEmails()" id="goto_more_emails"><span class="indicator-label">' + i18n.__('search_show_more') + '</span><span class="indicator-progress">Please wait... <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span></a></div>' : '';
				_html += data.emails && data.emails.length ? '<div class="tab-pane fade show active" id="search_emails" role="tabpanel"><div class="mt-5">' + _html_emails + _more_emails + '</div></div>' : '';
				//- CUSTOMERS
				$.each(data.customers, function (i, v) {
					_html_customers += _searchHtml(v, 'customer');
				})
				var _more_customers = data.count_customers > 10 ? '<div class="mt-10"><a class="btn btn-info btn-sm" href="#" onclick="goToDoSearchCustomers()" id="goto_more_contacts"><span class="indicator-label">' + i18n.__('search_show_more') + '</span><span class="indicator-progress">Please wait... <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span></a></div>' : '';
				_html += data.customers && data.customers.length ? '<div class="tab-pane fade" id="search_customers" role="tabpanel"><div class="mt-5">' + _html_customers + _more_customers + '</div></div>' : '';
				//- COMPANIES
				$.each(data.companies, function (i, v) {
					_html_companies += _searchHtml(v, 'companies');
				})
				var _more_companies = data.count_companies > 10 ? '<div class="mt-10"><a class="btn btn-info btn-sm" href="#" onclick="goToDoSearchCompanies()" id="goto_more_companies"><span class="indicator-label">' + i18n.__('search_show_more') + '</span><span class="indicator-progress">Please wait... <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span></a></div>' : '';
				_html += data.companies && data.companies.length ? '<div class="tab-pane fade" id="search_companies" role="tabpanel"><div class="mt-5">' + _html_companies + _more_companies + '</div></div>' : '';
				//- FILES
				$.each(data.files, function (i, v) {
					_html_files += _searchHtml(v, 'files');
				})
				var _more_files = data.count_files > 10 ? '<div class="mt-10"><a class="btn btn-info btn-sm" href="#" onclick="goToDoSearchFiles()" id="goto_more_companies"><span class="indicator-label">' + i18n.__('search_show_more') + '</span><span class="indicator-progress">Please wait... <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span></a></div>' : '';
				_html += data.files && data.files.length ? '<div class="tab-pane fade" id="search_files" role="tabpanel"><div class="mt-5">' + _html_files + _more_files + '</div></div>' : '';
				//- MAILBOXES
				$.each(data.mailboxes, function (i, v) {
					_html_mailboxes += _searchHtml(v, 'mailbox');
				})
				_html += data.mailboxes && data.mailboxes.length ? '<div class="tab-pane fade" id="search_mailboxes" role="tabpanel"><div class="mt-5">' + _html_mailboxes + '</div></div>' : '';
				//- NAVIGATION
				$.each(data.navigation, function (i, v) {
					var _click = v.js ? v.js : null;
					_html_navigation += _searchHtml(v, 'navigation');
				})
				_html += data.navigation && data.navigation.length ? '<div class="tab-pane fade" id="search_navigation" role="tabpanel"><div class="mt-5">' + _html_navigation + '</div></div>' : '';
				//- Tabs
				var _tabs = '<ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap">';
				if (data.emails && data.emails.length) {
					_tabs += ` <li class="nav-item">
								<a class="nav-link text-active-primary me-6 active" data-bs-toggle="tab" href="#search_emails">Emails</a>
							</li>`;
				}
				if (data.customers && data.customers.length) {
					_tabs += ` <li class="nav-item">
								<a class="nav-link text-active-primary me-6" data-bs-toggle="tab" href="#search_customers">Contacts</a>
							</li>`;
				}
				if (data.companies && data.companies.length) {
					_tabs += ` <li class="nav-item">
								<a class="nav-link text-active-primary me-6" data-bs-toggle="tab" href="#search_companies">Companies</a>
							</li>`;
				}
				if (data.files && data.files.length) {
					_tabs += ` <li class="nav-item">
								<a class="nav-link text-active-primary me-6" data-bs-toggle="tab" href="#search_files">Files</a>
							</li>`;
				}
				if (data.mailboxes && data.mailboxes.length) {
					_tabs += ` <li class="nav-item">
								<a class="nav-link text-active-primary me-6" data-bs-toggle="tab" href="#search_mailboxes">Mailboxes</a>
							</li>`;
				}
				if (data.navigation && data.navigation.length) {
					_tabs += ` <li class="nav-item">
								<a class="nav-link text-active-primary me-6" data-bs-toggle="tab" href="#search_navigation">Navigation</a>
							</li>`;
				}

				_tabs += '</div>';
				//- HTML
				_html = _html ? '<div class="py-3">' + _tabs + '<div class="tab-content">' + _html + '</div></div>' : '';
				_html += '<div class="goto-items-end"></div>';
				//- Add to ele
				$('#goToModal #goto-append').removeClass('hidden').html(_html);
				//- Call function to use arrow keys
				//- callHmKeyNavigation();
				//- Reset submit
				_submit = false;
				//- Reset stored term
				_goto_term = null;
				//- goto-spinner
				$('#goToModal .goto-spinner').addClass('hidden');
			}
		}
	});
}
function _searchHtml(obj, type) {
	//- console.log('obj', obj);
	var _hover_color = `text-hover-${obj.color}`;
	var _color = `bg-light-${obj.color} bg-hover-light-${obj.color} ${_hover_color}`;
	var _icon = `${obj.icon}`;
	var _header = '';
	var _title = '';
	var _date = '';
	var _mailbox = '';
	var _mailbox_id = '';
	var _kind = '';
	var _text = '';
	var _click = '';
	var _status = '';
	var _modal_class = 'open-detail-modal';
	switch (type) {
		case 'email':
			_date = `<span class="fs-7 text-muted ms-3">${obj.last_communication_date}</span>`;
			_header = obj.subject;
			_title = obj.subject;
			_text = obj.excerpt;
			_mailbox = `<span class="noevent badge ms-2 fs-8 text-nowrap mail-item-mailbox bg-light-info text-gray-600" data-mailbox='${obj.mailbox_id._id}'>${obj.mailbox_id.name}</span>`;
			_mailbox_id = obj.mailbox_id._id;
			_status = `<span class="ms-3 noevent badge badge-light fs-8 text-nowrap text-uppercase">${obj.status}</span>`
			_kind = 'email';
			break;
		case 'customer':
			_header = obj.name;
			_title = obj.name;
			_text = obj.email + `<button class="btn btn-light btn-icon btn-xs btn-clipboardjs ms-1 noevent" type="button" data-clipboard-text='${obj.email}'><span class='${_fa_style_light}clone'></span></button>`;
			_kind = 'contact';
			break;
		case 'companies':
			_header = obj.name;
			_title = obj.name;
			_text = obj.dns;
			_kind = 'company';
			break;
		case 'mailbox':
			_header = `<span class="noevent mail-item-mailbox ms-n3" data-mailbox='${obj._id}'>${obj.name}</span>`;
			_title = obj.name;
			_text = obj.email + `<button class="btn btn-light btn-icon btn-xs btn-clipboardjs ms-1 noevent" type="button" data-clipboard-text='${obj.email}'><span class='${_fa_style_light}clone'></span></button>`;
			_hover_color = `${_hover_color} noevent mail-item-mailbox`;
			_mailbox_id = obj._id;
			break;
		case 'navigation':
			_header = obj.display;
			_title = obj.display;
			_click = `onclick="${obj.js}"`;
			break;
		case 'files':
			_header = obj.name;
			_title = obj.name;
			_text = obj.excerpt;
			_click = `onclick="filesFileSlider('${obj._id}', null);return false;"`;
			_modal_class = '';
			break;
	}
	return `<div data-type="${type}" data-title="${_title}" data-id="${obj._id}" data-mailbox="${_mailbox_id}" data-kind="${_kind}" ${_click} class="goto-item d-flex align-items-start mb-2 py-2 hoverable bg-hover-light ${_modal_class} ${_hover_color}">
				<div class="ps-2 w-30px symbol symbol-30px flex-shrink-0 me-4">
					<div class="symbol-label hoverable inherit-color ${_color}">
						<span class="fa-1x ${_fa_style_light}${_icon}"></span>
					</div>
				</div>
				<div class="ps-2">
					<span class="text-gray-800 fw-bolder mb-1 inherit-color fs-6">${_header}${_status}${_date}
						<div class="text-muted fw-bold fs-7 goto-item-excerpt">${_text}${_mailbox}</div>
					</span>
				</div>
			</div>`;
}
//- Show advanced search form
function mailShowAdvancedSearch() {
	//- if div open close it
	if ($('.mail_advanced_search_div').is(':visible')) {
		$('.mail_advanced_search_div').addClass('hidden');
		return;
	}
	//- Show div
	$('.mail_advanced_search_div').removeClass('hidden');
	//- Status
	$('#mail-search-adv-status-ddm').select2({
		dropdownParent: $('#goToModal'),
		placeholder: {
			id: "-1",
			text: ""
		}
	});
	//- Mailboxes
	getMailboxes().then(mb => {
		$('#mail-search-adv-mailbox-ddm').select2({
			data: mb,
			dropdownParent: $('#goToModal'),
			placeholder: {
				id: "-1",
				text: ""
			}
		});
	});
	//- Users
	getAccountUsers().then(d => {
		$(`#mail-search-adv-users-ddm`).select2({
			data: d.select2,
			dropdownParent: $('#goToModal'),
			placeholder: {
				id: "-1",
				text: ""
			}
		});
	})
	//- Labels
	lfGetItem('mail_labels_' + _getHostIdCookie()).then(l => {
		$(`#mail-search-adv-labels-ddm`).select2({
			data: l,
			dropdownParent: $('#goToModal'),
			placeholder: {
				id: "-1",
				text: ""
			}
		});
	})
	//- Date
	$(`#mail-search-adv-date-datem`).flatpickr({
		dateFormat: 'Y-m-d',
		altFormat: 'F j, Y',
		altInput: true,
		enableTime: false,
		maxDate: 'today',
		//- inline: true,
		//- defaultDate: new Date( moment.tz(`#{cookies.time.time_zone}`).subtract(1, 'd') )
	});
	//- Focus on search term
	$('#goToModal #go_to_termm').focus();
}
